<section>
  <app-form-header [menuDefinition]="menuDefinition" [showSave]="canManageIncorrectPayments" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-date-picker
            [control]="form.controls['businessTransactionDate']"
            [model]="dataContext.businessTransactionDate"
            [label]="'PAYMENT.DATE'"
            [readonly]="true"
          ></astral-date-picker>
          @if (hasBankgiroNumber) {
            <astral-input [control]="form.controls['bankgiroNumber']"></astral-input>
          }
          <astral-input [control]="form.controls['registrationTypeText']"></astral-input>
          <astral-input [control]="form.controls['companyName']"></astral-input>
          @if (hasOcr) {
            <astral-input [control]="form.controls['ocr']"></astral-input>
          }
          <app-money-box [control]="form.controls['amount']"></app-money-box>
          <app-money-box [control]="form.controls['balance']"></app-money-box>
          <astral-input [span]="'full'" [control]="form.controls['description']"></astral-input>
          @if (hasPayerName) {
            <astral-input
              [span]="'full'"
              [control]="form.controls['payerNameAndAddress']"
            ></astral-input>
          }
        </astral-layout-group>
      </section>
      <div class="astral-accordion-stack">
        @if (showTransactions) {
          <astral-accordion
            [header]="'INCORRECT_PAYMENT.TRANSACTIONS'"
            [helpText]="'INCORRECT_PAYMENT.TRANSACTIONS_DESCRIPTION'"
            [startExpanded]="true"
            [allowWidthExpansion]="true">
            <app-list-view
              [columnDefinition]="columnTransactionsDefinition"
              [itemsSource]="dataContext.incorrectPaymentTransactions"
              [preferencesKey]="'invoice.incorrect-payment.transactions'"
            ></app-list-view>
          </astral-accordion>
        }
        <astral-accordion [header]="'VERIFICATION.VERIFICATIONS'" [startExpanded]="true" [allowWidthExpansion]="true">
          <app-list-view
            [columnDefinition]="columnAccountingsDefinition"
            [itemsSource]="dataContext.accountingTransactions"
            [preferencesKey]="'invoice.incorrect-payment.accounting-transactions'"
          ></app-list-view>
        </astral-accordion>
      </div>
    </form>
  }
</section>
